import { Box, Center, Heading } from "@chakra-ui/react";
import HeatMapGrid from "./HeatMapGrid";
import { normalizeTimeOfDayChart } from "../store/timeOfDayChart";

const TimeOfDayChart = ({ data, xLabels, yLabels, title }) => {
  const chart = normalizeTimeOfDayChart({ data, xLabels, yLabels });

  return (
    <Center>
      <Box width="80%" alignItems="center">
        <Heading size="md" mb="20px" textAlign="center">
          {title}
        </Heading>
        <HeatMapGrid
          data={chart.data}
          xLabels={chart.xLabels}
          yLabels={chart.yLabels}
          cellRender={(x, y, value) => (
            <div title={`Pos(${x}, ${y}) = ${value}`}>{value}</div>
          )}
          xLabelsStyle={() => ({
            color: "#777",
            fontSize: ".8rem",
            fontWeight: "bold",
          })}
          yLabelsStyle={() => ({
            fontSize: ".7rem",
            textTransform: "uppercase",
            color: "#777",
          })}
          cellStyle={(_x, _y, ratio) => ({
            background: `rgb(26,115,232, ${ratio})`,
            fontSize: ".8rem",
            color: `rgb(0, 0, 0, ${ratio / 2 + 0.4})`,
          })}
          cellHeight="2rem"
          xLabelsPos="bottom"
          yLabelsPos="right"
        />
      </Box>
    </Center>
  );
};

export default TimeOfDayChart;
